import * as React from "react";
import { useParams } from "react-router";

import useWaitApiCall from "../../../hooks/useWaitApiCall";
import { Context, verifyMFA } from "../../../managerStore";
import MultiFactorAuthenticationForm from "../../../templates/manager/MultiFactorAuthenticationForm";

export default () => {
  const { dispatch, state } = React.useContext(Context);
  const { ott } = useParams<{ ott: string }>();
  const [calling, peep] = useWaitApiCall(state);
  const verifyMFAFunc = React.useCallback(
    (mfa_code: string) => {
      dispatch(peep(verifyMFA(ott.trim(), mfa_code)));
    },
    [dispatch, ott, peep],
  );

  return (
    <MultiFactorAuthenticationForm
      calling={calling}
      onSubmit={verifyMFAFunc}
      error={state.error}
    />
  );
};
